import {bindable, bindingMode, customElement, containerless} from "aurelia-framework";

@containerless()
@customElement("popup-menu-category")
export class PopupMenuCategory {

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) label;

}
